import { useEffect, useRef, useState } from 'react';

/**
 * Custom hook that detects if an element is sticky based on its intersection with the viewport.
 * @param {Object} options - The options for the hook.
 * @param {string} options.rootMargin - The margin around the root
 * element to use when calculating the intersection.
 * @returns {Object} - An object containing the ref and isSticky state value.
 */
function useSticky({ rootMargin }) {
  const ref = useRef(null);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const spy = ref.current;
    const observer = new IntersectionObserver(([entry]) => {
      setIsSticky(!entry.isIntersecting);
    }, { rootMargin });

    if (spy) {
      observer.observe(spy);
    }

    return () => {
      if (spy) observer.unobserve(spy);
    };
  }, []);

  return { ref, isSticky };
}

export default useSticky;
